import { Pipe, PipeTransform } from '@angular/core';
import { HOLD } from 'ngrx/status-types';

import { ActivityHistory } from '../../models';

@Pipe({
  name: 'holdReason'
})
export class HoldReasonPipe implements PipeTransform {
  transform(records: ActivityHistory[]) {
    if (!records) return [];

    return records.sort(({ timestamp: t1 }, { timestamp: t2 }) => +t2 - +t1).find(ah => ah.activity === HOLD || ah.activity === 'HOLD').note;
  }
}


// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/shared/pipes/activity-history-hold-reason.pipe.ts